module.exports = __webpack_public_path__ + "img/t4-intro-text.e5fba226.png";